export const atLeastOneId = {
    matcher: (item: { externalId?: string; id?: string }) =>
        (item.externalId && item.externalId !== '') ||
        (item.id && item.id !== ''),
    options: {
        path: ['externalId', 'id'],
        message: 'Either the id, or the external id must be provided',
    },
}
